import Vue from 'vue'
import VueRouter from 'vue-router'
import Adaptation from './adaptation'
import BaseLayout from 'components/layout'
import NestedRoutes from 'components/NestedRoutes'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: BaseLayout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Adaptation('Home')
      },
      {
        path: '/about',
        name: 'About',
        component: Adaptation('About')
      },
      {
        path: '/Career',
        name: 'Career',
        component: Adaptation('Career')
      },
      {
        path: '/department',
        component: NestedRoutes,
        children: [
          {
            path: '',
            name: 'Department',
            component: Adaptation('Department')
          },
          {
            path: ':id',
            name: 'DepartmentInfo',
            // TODO
            component: Adaptation('DepartmentInfo')
          }
        ]
      },
      {
        path: '/blog',
        component: NestedRoutes,
        children: [
          {
            path: '',
            name: 'Blog',
            component: Adaptation('Blog'),
          },
          {
            path: ':id',
            name: 'BlogDetail',
            // TODO
            component: Adaptation('BlogDetail'),
          }
        ]
      },
      {
        path: '/zone',
        component: NestedRoutes,
        children: [
          {
            path: '',
            name: 'Zone',
            component: Adaptation('Zone'),
          },
          {
            path: ':id',
            name: 'ZoneDetail',
            // TODO
            component: Adaptation('ZoneDetail'),
          }
        ]
      },

    ]
  },
  {
    path: '*',
    name: '404',
    component: Adaptation('NotFound')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  // 路由变化时，触发全局的路由变化方法
  Vue.prototype.$store.routerChange(to, from)
  next()
})





export default router
